import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { CustomSerializer } from './custom-route-serializer';
import { reducers } from '../modal/app/app.reducer';

import { FareStoreModule } from './fare';
import { PnrStoreModule } from './pnr';
import { StopListStoreModule } from './stop';
import { PlanListStoreModule } from './plans';
import { ReStopListStoreModule } from './re-stop';
import { ClubStoreModule } from './club';

@NgModule({
  imports: [
    CommonModule,
    FareStoreModule,PnrStoreModule,StopListStoreModule,PlanListStoreModule,ReStopListStoreModule,ClubStoreModule,
    // Single root store (NgRx 9+ rejects a second forRoot). Runtime immutability checks off, as in NgRx 8.
    StoreModule.forRoot(reducers, { runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false } }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25 
    }),
    StoreRouterConnectingModule.forRoot({ serializer: CustomSerializer}),
  ],
  declarations: []
})
export class RootStoreModule {}
